// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__8pICp","row":"ProcedureTreatmentSummary_row__RjlMV"};